export const stationKindValues = ['pos', 'scale', 'kiosk', 'backoffice'] as const;
export type StationKind = (typeof stationKindValues)[number];

export const stationStatusValues = ['active', 'disabled'] as const;
export type StationStatus = (typeof stationStatusValues)[number];

export interface StationDto {
  id: string; // UUID
  companyId: string;
  storeId: string;
  locationId: string;
  name: string;
  kind: StationKind;
  isOfflineCapable: boolean;
  status: StationStatus;
  createdAt: string; // ISO timestamp
  updatedAt: string; // ISO timestamp
  // Invariants: station.companyId/storeId/locationId must reference the same tenant hierarchy.
}

export interface CreateStationRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  name: string;
  kind: StationKind;
  isOfflineCapable: boolean;
}

export interface CreateStationResponse {
  station: StationDto;
}

export interface UpdateStationRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  name?: string;
  kind?: StationKind;
  isOfflineCapable?: boolean;
  status?: StationStatus;
}

export interface UpdateStationResponse {
  station: StationDto;
}

export interface GetStationRequest {
  companyId: string;
  stationId: string;
}

export interface GetStationResponse {
  station: StationDto;
}

export interface ListStationsByLocationRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  page?: number;
  pageSize?: number;
}

export interface ListStationsByLocationResponse {
  items: StationDto[];
  page: number;
  pageSize: number;
  total: number;
}
